import React, { useState } from "react";
import { Tab, Nav, Card } from "react-bootstrap";
import GeneralInfo from "./forms/GeneralInfo";
import ProfilePhoto from "./forms/ProfilePhoto";
import CoverPhoto from "./forms/CoverPhoto";
import AccountType from "./forms/AccountType";
import { useProfileContext } from "provider/ProfileProvider";
import { Link, useNavigate } from "react-router-dom";
import { useToast } from "provider/ToastProvider";
import { useAuth } from "provider/AuthContext";
import apiCall from "components/Api/api";
import { handleError } from "components/Api/handleError";

const ProfileSettingsTabs = ({ genInfoSubmit, profilePhotoSubmit, coverPhotoSubmit }) => {
  const { activeTab, profileDispatch } = useProfileContext();
  const [loading, setLoading] = useState(false);
  const { showErrorToast, showSuccessToast } = useToast();
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleTabSelect = (key) => {
    profileDispatch({
      type: "SET_ACTIVE_TAB",
      payload: key
    });
  };

  const renderActiveTab = () => {
    switch (activeTab) {
      case "general":
        return <GeneralInfo genInfoSubmit={genInfoSubmit} />;
      case "profile-photo":
        return <ProfilePhoto profilePhotoSubmit={profilePhotoSubmit} />;
      case "cover-photo":
        return <CoverPhoto coverPhotoSubmit={coverPhotoSubmit} />;
      case "account-type":
        return <AccountType />;
      default:
        return null;
    }
  };

  const deactivateAccount = async (e) => {
    e.preventDefault();
    const isConfirmed = window.confirm("Are you sure you want to deactivate account?");

    if (!isConfirmed) {
      // If the user clicks "No", simply return without doing anything
      return;
    }

    try {
      setLoading(true);
      const response = await apiCall({
        url: "deactivate-account",
        method: "POST",
      });
      if (response.status !== 200) {
        throw new Error(`Unexpected status code: ${response.status}`);
      }

      const apiData = response.data;
      if (apiData?.errors && Object.keys(apiData.errors).length > 0) {
        const errors = apiData.errors;
        // Dynamically set errors based on the response
        Object.keys(errors).forEach((key) => {
          const errorMessages = errors[key];
          const firstErrorMessage = errorMessages[0];
          // Set the error state for the corresponding field
          showErrorToast(firstErrorMessage)

        });
        return;
      }
      if (apiData?.status === 1) {
        showSuccessToast(apiData?.message);
        setTimeout(() => {
          logout();
        }, 1500);
      }
    } catch (error) {
      console.error("Error submitting form:", error.message);
      // Optionally show error UI feedback here
      handleError(error, logout, navigate);

    } finally {

      profileDispatch({
        type: "SET_GEN_INFO_LOADING",
        payload: false
      });
    }
  };

    const deleteAccount = async (e) => {
    e.preventDefault();
    const isConfirmed = window.confirm("Are you sure you want to delete account?");

    if (!isConfirmed) {
      // If the user clicks "No", simply return without doing anything
      return;
    }

    try {
      setLoading(true);
      const response = await apiCall({
        url: "request-delete-account",
        method: "POST",
      });
      if (response.status !== 200) {
        throw new Error(`Unexpected status code: ${response.status}`);
      }

      const apiData = response.data;
      if (apiData?.errors && Object.keys(apiData.errors).length > 0) {
        const errors = apiData.errors;
        // Dynamically set errors based on the response
        Object.keys(errors).forEach((key) => {
          const errorMessages = errors[key];
          const firstErrorMessage = errorMessages[0];
          // Set the error state for the corresponding field
          showErrorToast(firstErrorMessage)

        });
        return;
      }
      if (apiData?.status === 1) {
        showSuccessToast(apiData?.message);
        setTimeout(() => {
          logout();
        }, 1500);
      }
    } catch (error) {
      console.error("Error submitting form:", error.message);
      // Optionally show error UI feedback here
      handleError(error, logout, navigate);

    } finally {

      profileDispatch({
        type: "SET_GEN_INFO_LOADING",
        payload: false
      });
    }
  };

  return (
    <>
      <Card className="account-settingside safartabs">
        <Card.Body className="p-4">
          <Tab.Container activeKey={activeTab} onSelect={handleTabSelect}>
            <Nav
              className="nav nav-tabs mb-4 slider_accountsetting border-bottom"
              role="tablist"
            >
              <Nav.Item role="presentation">
                <Nav.Link eventKey="general">General Information</Nav.Link>
              </Nav.Item>
              <Nav.Item role="presentation">
                <Nav.Link eventKey="profile-photo">Profile Photo</Nav.Link>
              </Nav.Item>
              <Nav.Item role="presentation">
                <Nav.Link eventKey="cover-photo">Cover Photo</Nav.Link>
              </Nav.Item>
              {/* <Nav.Item role="presentation">
              <Nav.Link eventKey="account-type">Account Type</Nav.Link>
            </Nav.Item> */}
            </Nav>

            <div className="form-inputssetting">{renderActiveTab()}</div>
          </Tab.Container>
        </Card.Body>
      </Card>
      <Card className="account-settingside safartabs mt-3">
        <Card.Body className="p-4">
          <p>
            <span className="text-danger">Important:</span> If you proceed with deactivating your Walk Into The Wild account, please be aware that your user profile will be deactivate. For our valued partners, this action will also deactivate your partner profile, immediately stopping any partner-specific features or visibility.



          </p>
          <p>
            Are you certain you wish to deactivate your account?
          </p>
          <div className="float-end">
            <div className="safari text-center">
              <div className="joinsafari leavesafrai">
                <Link
                  onClick={(e) => {
                    if (loading) {
                      e.preventDefault();
                      return;
                    }
                    deactivateAccount(e)
                  }}
                  disabled={loading}
                >
                  Deactivate Account
                </Link>
              </div>
            </div>
          </div>
        </Card.Body>
      </Card>
        <Card className="account-settingside safartabs mt-3">
        <Card.Body className="p-4">
          <p><span className="text-danger">Important:</span> Your account will be deactivated immediately. Our system will process the permanent deletion of all your data over the next 90 days. After this 90-day period, your account and all associated information will be permanently removed.</p>
          <p>If you are a partner, your partner profile will also be deactivated immediately, and your data will be permanently deleted during this 90-day period.</p>

          <p>
            Do you wish to continue with this account deletion request?
          </p>
          <div className="float-end">
            <div className="safari text-center">
              <div className="joinsafari leavesafrai">
                <Link
                  onClick={(e) => {
                    if (loading) {
                      e.preventDefault();
                      return;
                    }
                    deleteAccount(e)
                  }}
                  disabled={loading}
                >
                  Delete Account
                </Link>
              </div>
            </div>
          </div>
        </Card.Body>
      </Card>
    </>
  );
};

export default ProfileSettingsTabs;
